module.exports = __webpack_public_path__ + "static/img/dd_reply.fe62e52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/dd_reply.png
// module id = 1753
// module chunks = 0